
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";

// import * as api from "../constant/API";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const Vendor = () => {

    const [searchInput, setSearchInput] = useState("");
    const [vendorList, setVendorList] = useState([]);
    const [vendorId, setVendorId] = useState("");
    const [vendorName, setVendorName] = useState("");
    const [contactName, setContactName] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [email, setEmail] = useState("");
    const [vendorAddress, setVendorAddress] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        vendrList(null);
    }, [])

    function vendrList(id: string | null) {
        let getVendorList = api.VendorList;
        if (id) {
            getVendorList += '/' + id;
        }
        fetch(getVendorList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((vendResponse) => vendResponse.json())
            .then((vendResult) => {
                if (vendResult.code == 401) {
                    Utils.logoutUser();
                }
                if (id) {
                    setVendorId(vendResult.data[0].vendorId)
                    setVendorName(vendResult.data[0].vendorName)
                    setVendorAddress(vendResult.data[0].vendorAddress)
                    setContactName(vendResult.data[0].vendorContactName)
                    setContactNumber(vendResult.data[0].vendorPhone)
                    setEmail(vendResult.data[0].vendorEmail)
                } else {
                    setVendorList(vendResult.data)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch vendor list", error);
            })
    }

    function editVendor(rowData) {
        const vndrid = rowData.vendorId;
        vendrList(vndrid);
        setIsEdit(true)
        setOpenModal(true)
    }

    function saveVendor() {
        if (isEdit) {
            updateVendor()
        } else {
            const formData = new FormData();
            formData.append('vendorName', vendorName);
            formData.append('vendorAddress', vendorAddress);
            formData.append('vendorContactName', contactName);
            formData.append('vendorPhone', contactNumber);
            formData.append('vendorEmail', email)

            const createVendor = api.CreateVendor;
            fetch(createVendor, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
        setOpenModal(false);
    }

    function updateVendor() {
        const formData = new FormData();
        formData.append('vendorEditId', vendorId);
        formData.append('vendorNameEdit', vendorName);
        formData.append('vendorAddressEdit', vendorAddress);
        formData.append('vendorContactNameEdit', contactName);
        formData.append('vendorPhoneEdit', contactNumber);
        formData.append('vendorEmailEdit', email)

        const vendorUpdate = api.UpdateVendor;
        fetch(vendorUpdate, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function setInitial() {
        setVendorId('')
        setVendorName('')
        setVendorAddress('')
        setContactName('')
        setContactNumber('')
        setEmail('')
    }

    const filteredData = vendorList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.vendorName}</span>;
    };

    const phoneRender = (rowData) => {
        return <span>{rowData.vendorPhone}</span>;
    };

    const emailRender = (rowData) => {
        return <span>{rowData.vendorEmail}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editVendor(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == '1'|| roleId == '3' ? (
                                            <>
                                                <div className="row col-lg-12">
                                                    <div className="save-changes">
                                                        <Button
                                                            className="btn-secondary text-uppercase"
                                                            variant="success"
                                                            onClick={() => { setOpenModal(true); setIsEdit(false); setInitial() }}
                                                        >
                                                            <i className="fas fa-plus">Add Vendor</i>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-lg-6">
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slno"
                                                    header="Sl No"
                                                    body={slNoRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="vendorName"
                                                    header="Vendor Name"
                                                    body={nameRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="vendorPhone"
                                                    header="Vendor Phone"
                                                    body={phoneRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="vendorEmail"
                                                    header="Vendor Email"
                                                    body={emailRender}
                                                ></Column>
                                                {(roleId == '1'|| roleId == '3') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                <Modal
                    show={openModal}
                    size="md"
                    centered
                    onHide={() => setOpenModal(false)}>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 text-uppercase"><i className="fas fa-plus" />{isEdit ? "Edit" : "Add"} Vendor</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <div className="col-lg-12 mb-10">
                            <label className="form-label">Vendor Name</label>
                            <input
                                type="text"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                id="vndrName"
                                value={vendorName}
                                onChange={(e) => setVendorName(e.target.value)}
                                placeholder="Vendor Name"
                            />
                        </div>
                        <div className="col-lg-12 mb-10">
                            <label className="form-label">Contact Name</label>
                            <input
                                type="text"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                id="cntctNme"
                                value={contactName}
                                onChange={(e) => setContactName(e.target.value)}
                                placeholder="Contact Name"
                            />
                        </div>
                        <div className="col-lg-12 mb-10">
                            <label className="form-label">Contact Number</label>
                            <input
                                type="text"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                id="cntctNmbr"
                                value={contactNumber}
                                onChange={(e) => setContactNumber(e.target.value)}
                                placeholder="Contact Number"
                            />
                        </div>
                        <div className="col-lg-12 mb-10">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email"
                            />
                        </div>
                        <div className="col-lg-12 mb-10">
                            <label className="form-label">Vendor Address</label>
                            <input
                                type="textarea"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                id="vndrAdress"
                                value={vendorAddress}
                                onChange={(e) => setVendorAddress(e.target.value)}
                                placeholder="Vendor Address"
                            />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={() => { saveVendor(); setOpenModal(false) }}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b><i className="fas fa-save" />{isEdit ? " Update" : " Save"}</b>
                        </Button>
                    </ModalFooter>
                </Modal>
            }
        </>
    );
};

export default Vendor;